export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_2-87aee2cba0074c9eb27290349b67b5dd.png";